import React, { useEffect } from "react";
import GraphAmountSec from "../components/GraphAmountSec";
import ReturnAnalysis from "../components/ReturnAnalysis";
import DataTableown from "../components/DataTableown";
import HttpClientXml from "../../../../Utils/HttpClientXmInv";
import "./dashboard.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";

async function loginDashBoard(token: any) {
  await HttpClientXml.loginAs(token);
}
const InvestorDashboard = () => {
  const token = useSelector((state: RootState) => state.auth.token);
  useEffect(() => {
    loginDashBoard(token);
  }, []);

  return (
    <div>
      <div className="RestPage">
        <div className="container-fluid">
          <div className="invertorFirstRow mb-3">
            <GraphAmountSec />
          </div>
          <div className="row" style={{ marginTop: 28 }}>
            <div className="col">
              <div className="eStateTableDiv">
                <p className="eStateHead">Transaction Records</p>
                <div className="dataTableDiv">
                  <DataTableown />
                </div>
              </div>
            </div>
          </div>

          <p className="note">
            Net Interest: Interest received by the Investor, net of platform
            fees.
            <br />
            Additional Interest: Interest received after the Note&apos;s
            maturity date, net of platform fees.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InvestorDashboard;
